// Clash Games Theme Constants

export const APP_VERSION = '2.0'

export const CLASH_ASSETS = {
  clashLogo: '/CLASH Logo.png',
  gameIcon: '/Clashdle Icon.png',
  occLogo: '/Roslyn OCC Games Logo.png',
  occGamesLogo: '/Roslyn OCC Games Logo.png',
  occLogoWhite: '/Roslyn OCC Games Logo White.png',
} as const

export const CLASH_STORAGE_KEYS = {
  adminAuth: 'clashdle_admin_auth',
  adminWordList: 'clashdle_admin_words',
  currentWord: 'clashdle_currentWord',
  nextWord: 'clashdle_nextWord',
  wordSchedule: 'clashdle_wordSchedule',
  gameState: 'clashdle_gameState',
  gameStats: 'clashdle_gameStats',
  hasSeenHowToPlay: 'clashdle_hasSeenHowToPlay',
} as const

export const CLASH_CREDITS = {
  developers: ['Jordan Feldstein', 'Olivia Jacobson'],
  organization: 'Roslyn OCC',
  year: new Date().getFullYear(),
} as const

export const CLASH_LINKS = {
  occ: 'https://www.roslynocc.com',
  privacy: 'https://www.roslynocc.com/privacy',
} as const
